import { Nullable } from './Types';
import { emptyGuid } from './Constants';

export const referenceToString = (it: { name: string }): string => it.name;

export const referenceToKey = (it: { code: string }): string => it.code;

export const lookupIdentifierToName = (it: Nullable<{ name?: string }>): string => it?.name || '';

export const lookupIdentifierToKey = (it: Nullable<{ id: string }>): string => it?.id || 'keyMissing';

export const lookupIdentifierToAuthSystemKey = (
    it: Nullable<{ authoringSystem: string; authoringSystemForeignKey: string }>
): string => {
    if (it?.authoringSystem && it?.authoringSystemForeignKey) {
        return it.authoringSystem + it.authoringSystemForeignKey;
    }
    return 'keyMissing';
};

export const compareLookupIdentifiers = (a: Nullable<LookupIdentifier>, b: Nullable<LookupIdentifier>) =>
    a?.id === b?.id;

export const convertToLookUpIdentifier = (it: LookupIdentifier): LookupIdentifier => {
    return {
        id: it.id,
        authoringSystem: it.authoringSystem,
        authoringSystemForeignKey: it.authoringSystemForeignKey
    };
};

export function isLookupIdentifier<T>(thing: T | LookupIdentifier): thing is LookupIdentifier {
    return (thing as LookupIdentifier).name !== undefined;
}

export interface Reference {
    code: string;
    name: string;
    codingSystemUri?: string;
    codingSystemVersion?: string;
    codingSystemValue?: string;
}

export type OrderedReference = Reference & {
    orderNumber: number;
};

export interface LookupIdentifier {
    id: string;
    authoringSystem: string;
    authoringSystemForeignKey: string;
    name?: string;
}

// Open for discussion on better ways to do this
export interface ExternalLookupIdentifier {
    authoringSystem: string;
    authoringSystemForeignKey: string;
    name?: string;
}

export interface ClientEvent {
    clientQueueName: string;
}

export function joinLookupIdentifierNamesWithCommas(items: LookupIdentifier[]): string {
    return items.map(item => item.name).join(', ');
}

export type ServiceLookupInput = {
    id?: string;
    authoringSystem: string;
    authoringSystemForeignKey: string;
};

export const buildServiceLookupIdentifier = (service: ServiceLookupInput): LookupIdentifier => ({
    id: service.id ?? emptyGuid,
    authoringSystem: service.authoringSystem,
    authoringSystemForeignKey: service.authoringSystemForeignKey,
    name: undefined
});
